import type { OrgMember } from 'types/api.generated';

export function getMemberDisplayName(member: OrgMember): string {
  const { user } = member;
  const name = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();
  return name || user.email;
}

/** Active members who are not in the driver role (owner, admin, editor, etc.). */
export function getNonDriverMembers(members: OrgMember[]): OrgMember[] {
  return members.filter((m) => m.role.slug !== 'driver');
}

/** Members not on the fleet drivers roster (includes driver role without enabled profile). */
export function getMembersWithoutDriverProfile(
  members: OrgMember[],
  driverUserIds: Set<string>,
): OrgMember[] {
  return members.filter((m) => !driverUserIds.has(m.userId));
}
